import { render, staticRenderFns } from "./widgetProfile.vue?vue&type=template&id=2a5bf4e4&scoped=true"
import script from "./widgetProfile.vue?vue&type=script&lang=js"
export * from "./widgetProfile.vue?vue&type=script&lang=js"
import style0 from "./widgetProfile.vue?vue&type=style&index=0&id=2a5bf4e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a5bf4e4",
  null
  
)

export default component.exports